import {
  trackOrganizationFailed,
  trackOrganizationSubmitted,
} from '@services/mixpanel/trackers/UserSessionMetrics';
import { getOrganizationByName as getOrganizationIdByName } from '@services/queries/auth0';
import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { OrgStates } from '../Organization.types';
import { SetState } from '../utils/onOrgNameSubmit';

interface OrgIdParams {
  email: string;
  isSubmitSuccessful: boolean;
  setOrgFormState: SetState<OrgStates>;
}

export function useOrgIdQuery(params: OrgIdParams) {
  const { email, isSubmitSuccessful, setOrgFormState } = params;

  type RetType = Awaited<ReturnType<typeof getOrganizationIdByName>>;

  return useQuery<RetType, AxiosError>(
    ['orgId', email],
    () => getOrganizationIdByName(email as string),
    {
      retry: false,
      // Enable it only when we are in the state where we are submitting
      // IN paticular, only when the form is in a submitted state.
      enabled: isSubmitSuccessful,
      onSuccess() {
        trackOrganizationSubmitted(email);
      },
      onError: err => {
        // one of two
        trackOrganizationFailed(email);
        if (err.response && err.response.data.message === 'Studio expired') {
          setOrgFormState('expired');
        }
        // Initial state doesn't matter as when this is fired we will have interacted at most once already
        // Reset state and disable the query
        else {
          setOrgFormState('error');
        }
      },
    },
  );
}
